import React, { Fragment } from "react";
import NavBar from "./pages/Layout/NavBar/NavBar";
import { Outlet, useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
import WelcomePage from "./WelcomPage";

function App() {
  const location = useLocation();

  return (
    <Fragment>
        <NavBar />
        {location?.pathname === "/" ? (
          <WelcomePage />
        ) : (
          <Grid container margin={"0px auto"} className="App" maxWidth={"xl"}>
            <Outlet />
          </Grid>
        )}
      </Fragment>
  );
}

export default App;
